import _ from 'underscore';
import Promise from 'bluebird';

export class PreferencesSubadapter {
  constructor({
    preferenceService,
    Resource = null,
    prefix = '',
    serialize = _.identity,
    deserialize = _.identity,
  }) {
    this.preferenceService = preferenceService;
    this.prefix = _.isString(prefix) ? () => prefix : prefix;
    this.serialize = serialize;
    this.deserialize = deserialize;
    if (_.some([
      this.prefix,
      this.serialize,
      this.deserialize,
    ], _.negate(_.isFunction))) {
      throw new Error('Invalid arguments');
    }
    this.Resource = Resource;
  }

  create(attrs) {
    const data = this.serialize(attrs);

    return this.preferenceService
      .then(preferences => preferences.set(data, null, null))
      .then(({ Id }) => _.defaults({ id: Id }, attrs));
  }

  find(id) {
    return this.preferenceService.then(preferences => preferences.find(id));
  }

  findAll(params) {
    const prefix = this.prefix(params);

    return this.preferenceService
      .then(preferences => preferences.findByPrefix(prefix))
      .map(this.deserialize);
  }

  update(id, attrs) {
    const entity = _.defaults({}, attrs, this.Resource.get(id));
    const data = this.serialize(entity);

    return this.preferenceService
      .then(preferences => preferences.set(data, id, null))
      .thenReturn(entity);
  }

  destroy(id) {
    return this.preferenceService.then(preferences => preferences.del(id, null));
  }

  destroyAll() {
    return Promise.reject(new Error('Not implemented'));
  }
}

